import styles from "./ScholarshipJudgement.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";
import { useResponsiveness } from "hooks/useResponsiveness";
import Subsection from "../Subsection";
import Image from "@Components/Image";
import { SCHOLARSHIP_PAGE_STATIC_URL } from "constants/index";
import CommunicationIcon from "./icons/CommunicationIcon";
import PresentationIcon from "./icons/PresentationIcon";
import useTranslationHook from "hooks/useTranslationHook";

const ScholarshipJudgement = () => {
  const { isAbove } = useResponsiveness();
  const isTabletOrDesktop = isAbove("md");
  const { t } = useTranslationHook();

  const criteriaContent = (
    <div className={styles.criteriaList}>
      <div className={styles.criteriaItem}>
        <Image
          src={`${SCHOLARSHIP_PAGE_STATIC_URL}/execution_scholar.svg`}
          alt={t("scholarship.scholarshipjudgement.execution")}
          className={styles.criteriaIcon}
          width={24}
          height={24}
        />
        <span className={styles.criteriaText}>
          {t("scholarship.scholarshipjudgement.execution")}
        </span>
      </div>

      <div className={styles.criteriaItem}>
        <Image
          src={`${SCHOLARSHIP_PAGE_STATIC_URL}/creativity_scholar.svg`}
          alt={t("scholarship.scholarshipjudgement.ideation")}
          className={styles.criteriaIcon}
          width={24}
          height={24}
        />
        <span className={styles.criteriaText}>
          {t("scholarship.scholarshipjudgement.creativity")}
        </span>
      </div>

      <div className={styles.criteriaItem}>
        <Image
          src={`${SCHOLARSHIP_PAGE_STATIC_URL}/feasibility_scholar.svg`}
          alt={t("scholarship.scholarshipjudgement.feasibility")}
          className={styles.criteriaIcon}
          width={24}
          height={24}
        />
        <span className={styles.criteriaText}>
          {t("scholarship.scholarshipjudgement.feasibility")}
        </span>
      </div>

      <div className={styles.criteriaItem}>
        <CommunicationIcon />
        <span className={styles.criteriaText}>
          {t("scholarship.scholarshipjudgement.communication")}
        </span>
      </div>

      <div className={styles.criteriaItem}>
        <PresentationIcon />
        <span className={styles.criteriaText}>
          {t("scholarship.scholarshipjudgement.presentation")}
        </span>
      </div>

      <div className={styles.criteriaItem}>
        <Image
          src={`${SCHOLARSHIP_PAGE_STATIC_URL}/idea_scholar.svg`}
          alt={t("scholarship.scholarshipjudgement.creativity")}
          className={styles.criteriaIcon}
          width={24}
          height={24}
        />
        <span className={styles.criteriaText}>
          {t("scholarship.scholarshipjudgement.ideation")}
        </span>
      </div>
    </div>
  );

  if (isTabletOrDesktop) {
    return (
      <div className={styles.scholarshipJudgementContainer}>
        <div className={styles.content}>
          <h2 className={styles.title}>{t("scholarship.scholarshipjudgement.title")}</h2>
          <div className={styles.description}>
            <p className={styles.applicationInfo}>
              {t("scholarship.scholarshipjudgement.description")}
            </p>
          </div>
          {criteriaContent}
        </div>
      </div>
    );
  }

  return (
    <Subsection
      title={t("scholarship.scholarshipjudgement.title")}
      subtitle={t("scholarship.scholarshipjudgement.description")}
      withSidePadding
      titleH2
    >
      {criteriaContent}
    </Subsection>
  );
};

export default wrapperHOC(ScholarshipJudgement, {
  componentName: "ScholarshipJudgement-ScholarshipDesktop",
  showForChina: true,
});
